export const SST_TYPES = {
  TRAJECTORY: 'TRAJECTORY',
  STATUS: 'STATUS',
  OPERATION: 'OPERATION',
} as const;

export type SstType = (typeof SST_TYPES)[keyof typeof SST_TYPES];
